<template>
  <div class="user-detail-info">
    <div class="user-detail-info-left">
      <div class='account-item' v-if='tgoUserInfo.city'>
        <span class='account-item-key'>所在城市：</span>
        <span class='account-item-value'>
          <span v-if="tgoUserInfo.country">{{country[tgoUserInfo.country]}} </span>
          <span v-if="province&&Number(tgoUserInfo.country)!==2">{{province.name}} </span>
          <span v-if="city">{{city.name}}</span>
        </span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.company'>
        <span class='account-item-key'>所在企业：</span>
        <span class='account-item-value'>{{tgoUserInfo.company}}</span>
      </div>
      <div class='account-item' v-if="jobTitles[0].name">
        <span class='account-item-key'>职位：</span>
        <span class='account-item-value'>{{tgoUserInfo.job_title_content && tgoUserInfo.job_title === '12' ? tgoUserInfo.job_title_content : jobTitles[0].name}}</span>
      </div>
      <div class='account-item' v-if="companyIndustrys">
        <span class='account-item-key'>行业领域：</span>
        <span class='account-item-value'>{{companyIndustrys}}</span>
      </div>
      <div class='account-item' v-if="companyTypes[0].name">
        <span class='account-item-key'>融资阶段：</span>
        <span class='account-item-value'>{{companyTypes[0].name}}</span>
      </div>
      <div class='account-item' v-if="companyScales[0].name">
        <span class='account-item-key'>企业规模：</span>
        <span class='account-item-value'>{{companyScales[0].name}}</span>
      </div>
      <div class='account-item' v-if="companyDevelops[0].name">
        <span class='account-item-key'>企业研发团队规模（人数）：</span>
        <span class='account-item-value'>
          {{companyDevelops[0].name}}
        </span>
      </div>
      <div class='account-item' v-if="teamSizes[0].name">
        <span class='account-item-key'>本人现带领团队规模（人数）：</span>
        <span class='account-item-value'>{{teamSizes[0].name}}</span>
      </div>
      <div class='account-item' v-if='developTeamSizes[0].name'>
        <span class='account-item-key'>本人曾带领团队最大规模（人数）：</span>
        <span class='account-item-value'>{{developTeamSizes[0].name}}</span>
      </div>
      <div class='account-item' v-if='developedStartTime'>
        <span class='account-item-key'>从事研发工作起始年：</span>
        <span class='account-item-value'>{{developedStartTime}}</span>
      </div>
      <div class='account-item' v-if='managedStartTime'>
        <span class='account-item-key'>从事管理工作起始年：</span>
        <span class='account-item-value'>{{managedStartTime}}</span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.work_experience'>
        <span class='account-item-key'>工作经历：</span>
        <pre class='account-item-value' v-html="tgoUserInfo.work_experience"></pre>
      </div>
      <div class='account-item' v-if='tgoUserInfo.achievements'>
        <span class='account-item-key'>项目经历：</span>
        <pre class='account-item-value' v-html="tgoUserInfo.achievements"></pre>
      </div>
      <div class='account-item' v-if='tgoUserInfo.study_experience'>
        <span class='account-item-key'>教育经历：</span>
        <pre class='account-item-value' v-html="tgoUserInfo.study_experience"></pre>
      </div>
      <div class='account-item' v-if='tgoUserInfo.support_resource'>
        <span class='account-item-key'>可提供的资源：</span>
        <pre class='account-item-value' v-html="tgoUserInfo.support_resource"></pre>
      </div>
      <div class='account-item' v-if='tgoUserInfo.want_resource'>
        <span class='account-item-key'>期望获得的价值：</span>
        <pre class='account-item-value' v-html="tgoUserInfo.want_resource"></pre>
      </div>
    </div>
    <div class="user-detail-info-right">
      <div class="modify-btn" @click="modifyFn">修改</div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import areaData from '@/config/areaData.js'

// static 数据
// jobTitles,companyIndustrys,companyTypes
// companyScales,companyDevelops,teamSizes

import * as staticDataMap from '@/data/form'

export default {
  data () {
    return {
      areaData,
      staticDataMap,
      country: {
        '1': '中国',
        '2': '美国'
      }
    }
  },
  props: ['tgoUserInfo'],
  computed: {
    province () {
      if (Number(this.tgoUserInfo.province) === 0) {
        return this.areaData['86'].filter(item => item.cid === Number(this.tgoUserInfo.country))[0] || [{ 'name': '', 'id': '' }]
      } else {
        return this.areaData['86'].filter(item => item.cid === Number(this.tgoUserInfo.country) && item.id === Number(this.tgoUserInfo.province))[0] || [{ 'name': '', 'id': '' }]
      }
    },
    city () {
      if (this.areaData[this.province.id]) {
        return this.areaData[this.province.id].childs.filter(item => item.id === Number(this.tgoUserInfo.city))[0] || [{ 'name': '' }]
      } else { return [{ 'name': '' }] }
    },
    managedStartTime () {
      return moment(this.tgoUserInfo.managed_start_year * 1000).format('YYYY')
    },
    developedStartTime () {
      return moment(this.tgoUserInfo.developed_start_year * 1000).format('YYYY')
    },
    jobTitles () {
      if (this.tgoUserInfo.job_title) {
        let arr = this.staticDataMap.jobTitles.filter(i => i.id === Number(this.tgoUserInfo.job_title))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    },
    companyIndustrys () {
      if (Array.isArray(this.tgoUserInfo.company_industry)) {
        let companyIndustrys = {}
        let string = ''
        this.staticDataMap.companyIndustrys.forEach(item => {
          companyIndustrys[item.id] = item
        })
        this.tgoUserInfo.company_industry.map(id => companyIndustrys[id]).forEach(item => {
          string = string + item.name + '、'
        })
        return string.substring(0, string.length - 1)
      } else {
        return ''
      }
    },
    companyTypes () {
      if (this.tgoUserInfo.company_type) {
        let arr = this.staticDataMap.companyTypes.filter(i => i.id === Number(this.tgoUserInfo.company_type))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    },
    companyScales () {
      if (this.tgoUserInfo.company_scale) {
        let arr = this.staticDataMap.companyScales.filter(i => i.id === Number(this.tgoUserInfo.company_scale))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    },
    companyDevelops () {
      if (this.tgoUserInfo.company_develop) {
        let arr = this.staticDataMap.companyDevelops.filter(i => i.id === Number(this.tgoUserInfo.company_develop))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    },
    teamSizes () {
      if (this.tgoUserInfo.managed_team_size) {
        let arr = this.staticDataMap.teamSizes.filter(i => i.id === Number(this.tgoUserInfo.managed_team_size))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    },
    developTeamSizes () {
      if (this.tgoUserInfo.development_team_size) {
        let arr = this.staticDataMap.teamSizes.filter(i => i.id === Number(this.tgoUserInfo.development_team_size))
        if (arr.length) {
          return arr
        } else {
          return [{ name: '' }]
        }
      } else {
        return [{ name: '' }]
      }
    }
  },
  methods: {
    modifyFn () {
      this.$emit('setState')
      this.$emit('notifyInfos')
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../../style/bulma/app.sass'

.user-detail-info
  display: flex
  justify-content: space-between
  .user-detail-info-left
    width: 80%
    .account-item
      padding: 8px 0
      display: flex
      .account-item-key
        word-break: keep-all
      .account-item-value
        word-break: break-word
      &.account-avatar
        display: flex
      .account-item-key
        color: #353535
      .account-item-value
        color: #888
      pre.account-item-value
        -webkit-font-smoothing: unset
        font-weight: 400
        background-color: transparent
        font-size: 16px
        padding: 0
        word-wrap: normal
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","\5FAE\8F6F\96C5\9ED1",Arial,sans-serif
        white-space: pre-wrap
        white-space: -moz-pre-wrap
        white-space: -pre-wrap
        white-space: -o-pre-wrap
        word-wrap: break-word
  .user-detail-info-right
    width: 15%
    display: flex
    justify-content: flex-end
    align-items: baseline
    .modify-btn
      padding: 5px 30px
      border: 1px solid $primary3
      color: $primary3
      border-radius: 5px
      cursor: pointer
      word-break: keep-all

</style>
